// planTypes.js
export const GET_PLANS_PENDING = 'GET_PLANS_PENDING';
export const PLANS = 'PLANS';
export const GET_PLAN_PENDING = 'GET_PLAN_PENDING';
export const PLAN = 'PLAN';
export const UPDATE_PLAN = 'UPDATE_PLAN';
export const UPDATE_PLAN_PENDING = 'UPDATE_PLAN_PENDING';
export const CREATE_PLAN = 'CREATE_PLAN';
export const CREATE_PLAN_PENDING = 'CREATE_PLAN_PENDING';
